/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28b36c4253b0180cd5e269ebbfd77329>>
 * @codegenCommand afm workspace @atlassian/logo-third-party generate:components
 */
import React from 'react';

import { ThirdPartyLogoWrapper } from '../wrapper';
import type { ThirdPartyLogoProps } from './types';

const markup =
	'<svg width="100%" height="100%" fill="none" viewBox="0 0 48 48"><path fill="#ffd02f" d="M16.633 11h14.734C34.454 11 37 13.546 37 16.633v14.734C37 34.454 34.454 37 31.367 37H16.633C13.546 37 11 34.454 11 31.367V16.633C11 13.546 13.546 11 16.633 11"/><path fill="#050038" fill-rule="evenodd" d="M29.038 14.242h-2.871l2.383 4.171-5.2-4.17h-2.87l2.6 5.09-5.417-5.09h-2.871l2.87 6.5-2.87 13h2.87l5.472-13.922-2.654 13.921h2.87l5.255-14.841-2.384 14.841h2.871l5.2-16.25z" clip-rule="evenodd"/></svg>';

/**
 * __MiroIcon__
 *
 * A third-party logo icon for Miro.
 */
export function MiroIcon({
	size,
	label = 'Miro',
	testId,
	type,
	UNSAFE_isUpdatedGeometry,
}: ThirdPartyLogoProps): React.JSX.Element {
	return (
		<ThirdPartyLogoWrapper
			markup={markup}
			label={label}
			size={size}
			testId={testId}
			type={type}
			UNSAFE_isUpdatedGeometry={UNSAFE_isUpdatedGeometry}
		/>
	);
}
